"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get AsyncTaskResponse () {
        return AsyncTaskResponse;
    },
    get AsyncTaskStatusStreamEvent () {
        return AsyncTaskStatusStreamEvent;
    },
    get AsyncTaskStatusUpdateEvent () {
        return AsyncTaskStatusUpdateEvent;
    },
    get AsyncTaskSummaryResponse () {
        return AsyncTaskSummaryResponse;
    },
    get GetActiveAsyncTaskSummariesResponse () {
        return GetActiveAsyncTaskSummariesResponse;
    },
    get GetAsyncTasksByNameResponse () {
        return GetAsyncTasksByNameResponse;
    },
    get PublicAsyncTaskMetadata () {
        return PublicAsyncTaskMetadata;
    }
});
const _zod = require("zod");
const _models = require("@performyard/models");
const _utilsisomorphic = require("@performyard/utils-isomorphic");
const AsyncTaskStatusUpdateEvent = _zod.z.object({
    _id: _zod.z.string(),
    name: _zod.z.string(),
    companyId: _zod.z.string(),
    userId: _zod.z.string().nullable(),
    status: _models.AsyncTaskStatusEnum,
    createdAt: _zod.z.string(),
    startedAt: _zod.z.string().nullable(),
    completedAt: _zod.z.string().nullable(),
    progressCount: _zod.z.number(),
    progressTotal: _zod.z.number(),
    metadata: _zod.z.record(_zod.z.string(), _zod.z.unknown()).optional(),
    error: _zod.z.string().optional()
});
const AsyncTaskResponse = _models.AsyncTaskModel.omit({
    error: true
}).extend({
    error: _zod.z.string().nullable().optional().transform((val)=>val ?? undefined)
});
const GetAsyncTasksByNameResponse = _zod.z.array(AsyncTaskResponse);
const PublicAsyncTaskMetadata = _models.AsyncTaskModel.shape.metadata.unwrap().pipe(_zod.z.union([
    _zod.z.object({
        reviewCycleId: _zod.z.string(),
        totalReviews: _zod.z.number()
    }),
    _zod.z.object({
        cycleId: _zod.z.string()
    }),
    _zod.z.object({
        surveyId: _zod.z.string()
    }),
    _zod.z.object({})
]));
const AsyncTaskSummaryResponse = _models.AsyncTaskModel.pick({
    name: true,
    status: true,
    progressCount: true,
    progressTotal: true
}).extend({
    _id: _utilsisomorphic.transformObjectId,
    metadata: PublicAsyncTaskMetadata.optional()
});
const GetActiveAsyncTaskSummariesResponse = _zod.z.array(AsyncTaskSummaryResponse);
const AsyncTaskStatusStreamEvent = AsyncTaskStatusUpdateEvent.extend({
    metadata: PublicAsyncTaskMetadata.optional()
});
